<template>
  <div class="admin_wishlists">
    <v-card>
      <v-toolbar flat color="white">
        <v-card-title>
          <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title @click="checkItems">
          {{user.name}}'s {{ $t('navigation_wishlist') }} 
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title>
          ({{wishlists.length}}) {{ $t('wishlist_item') }} 
        </v-card-title>
      </v-toolbar>
      <v-data-table :headers="headers" :items="wishlists"  :search="search" sort-by="name" class="elevation-1"><!--  -->
        <template v-slot:item.name="{ item }">
          <b>{{ item.product_name }}</b>
        </template>
        <template v-slot:item.image="{ item }">
          <v-img height="70px" width="70px" :src="getImage(item.product_image)"></v-img>
        </template>
        <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon medium color="orange darken-2" @click="deleteClient(item)">mdi-delete</v-icon>
                </span>
              </template>
              <span>{{ $t('remove') }}</span>
            </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>Wishlist Is Empty</b></v-list-item-title>
        </template>
      </v-data-table>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-card-title>
          <router-link to="/"><v-btn color="indigo darken-1" dark rounded><v-icon>mdi-home</v-icon>{{ $t('button_home') }}</v-btn></router-link> 
        </v-card-title>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase';

  export default {
    name : "admin_wishlists",
    data: () => ({
      search: '',
      nav_title: 'Wishlist Page',
      headers: [
        { text: 'Product Image', align: 'center', value: 'image' },
        { text: 'Product Name', align: 'center', value: 'name'},
        { text: 'Product Client', align: 'center', value: 'client_name'},
        { text: 'Region', align: 'center', value: 'client_town'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      wishlists: [],
      user: null,
      matchitems:[]
    }),

    created(){
      //fetch data from the firestore
      db.collection('wishlists').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let wishlist = doc.data()
          wishlist.id =  doc.id
          this.wishlists.push(wishlist) 
        })
      })
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },
    
    firestore() {
      return {
        carti: db.collection('wishlists')
      }
    },

    methods: {
      checkItems(){
        for(var i=0; i<=this.wishlists.length; i++){
          if(this.wishlist.user == this.user.alias){
            this.matchitems.push(this.wishlist)
          }
        }
      },
      getImage(product_image){
        return product_image[0]
      },

      back(){
        this.$router.go(-1)
      },
      
      deleteClient(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })/* eslint-enable */
        .then((result) => {
          if (result.value) {
            this.$firestore.carti.doc(item.id).delete()            
            /* eslint-disable */
            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
            /* eslint-enable */
            this.wishlists = this.wishlists.filter(wishlist =>{
            return wishlist.id != item.id
          })
          }
        })
      }
    }
  }
</script>
